import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import api from "../api/axios";

export default function Login() {
  const submit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

    const res = await api.post("/login", {
      email: data.get("email"),
      password: data.get("password"),
    });

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("role", res.data.role);
    window.location.href = "/";
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        background: "linear-gradient(120deg, #0f2027, #203a43, #2c5364)",
        backgroundSize: "400% 400%",
        animation: "gradient 12s ease infinite",
        "@keyframes gradient": {
          "0%": { backgroundPosition: "0% 50%" },
          "50%": { backgroundPosition: "100% 50%" },
          "100%": { backgroundPosition: "0% 50%" },
        },
      }}
    >
      {/* Left Illustration Section */}
      <Box
        sx={{
          flex: 1,
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          px: 6,
        }}
      >
        <Box>
          <img src="logo.webp" alt="Custom Remaps" width={'250px'} />
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Custom Remaps
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Admin Panel & Service Management
          </Typography>
          <Typography sx={{ mt: 2, maxWidth: 420, opacity: 0.8 }}>
            Manage vehicle remaps, trackers, immobilisers, training programs,
            payments, bookings, blogs, and analytics from one powerful
            dashboard.
          </Typography>
        </Box>
      </Box>

      {/* Right Login Card */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Paper
          elevation={10}
          sx={{
            width: "100%",
            maxWidth: 420,
            p: 4,
            borderRadius: 4,
            backdropFilter: "blur(12px)",
            background: "rgba(255,255,255,0.95)",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
          >
            Welcome Back
          </Typography>

          <Typography
            variant="body1"
            textAlign="center"
            color="text.secondary"
            sx={{ mb: 3 }}
          >
            Login to your admin account
          </Typography>

          <form onSubmit={submit}>
            <TextField
              fullWidth
              name="email"
              label="Email"
              type="email"
              required
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <TextField
              fullWidth
              name="password"
              label="Password"
              type="password"
              required
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                py: 1.5,
                fontWeight: "bold",
                borderRadius: 2,
                fontSize: 16,
                background: "linear-gradient(135deg, #1976d2, #42a5f5)",
                boxShadow: "0 8px 20px rgba(25,118,210,0.35)",
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 12px 25px rgba(25,118,210,0.45)",
                },
              }}
            >
              Login
            </Button>
          </form>

          <Typography
            variant="body2"
            textAlign="center"
            color="text.secondary"
            sx={{ mt: 3 }}
          >
            © {new Date().getFullYear()} Custom Remaps
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}
